import { styled, Box } from '@mui/material';

export const StyledVideo = styled(Box)(
  ({ size }: { size: 'small' | 'large' | 'fullscreen' | 'portrait' }) => {
    if (size === 'small') {
      return {
        width: 293,
        height: 164,
        position: 'absolute',
        overflow: 'hidden',
        right: 16,
        top: 16,
        // background: 'rgb(249, 250, 249)',
        borderRadius: 8,
      };
    } else if (size === 'portrait') {
      return {
        height: 293,
        width: 164,
        position: 'absolute',
        overflow: 'hidden',
        right: 16,
        top: 16,
        // background: 'rgb(249, 250, 249)',
        borderRadius: 8,
      };
    } else if (size === 'fullscreen') {
      return {
        width: '100%',
        height: '100%',
        position: 'relative',
        borderRadius: 8,
        overflow: 'hidden',
        mt: 6,
      };
    } else {
      // large size
      return {
        width: 1087,
        height: 612,
        position: 'relative',
        borderRadius: 8,
        overflow: 'hidden',
        mt: 6,
      };
    }
  }
);
